import {
    GET_FLEET_AFE_CHANGE_LOG,
    GET_FLEET_ASSET_CHANGE_LOG,
    SET_FLEET_AFE_CHANGE_LOG,
    SET_FLEET_ASSET_CHANGE_LOG
} from "./FleetAssetChangeLogType"

const getFleetAssetChangeLog = (fleetRequestDetailId: any) => ({
    type: GET_FLEET_ASSET_CHANGE_LOG,
    fleetRequestDetailId
})

const setFleetAssetChangeLog = (fleetAssetChangeLog?: any) => ({
    type: SET_FLEET_ASSET_CHANGE_LOG,
    fleetAssetChangeLog: fleetAssetChangeLog
})

const getFleetAfeChangeLog = (fleetRequestDetailId: any) => ({
    type: GET_FLEET_AFE_CHANGE_LOG,
    fleetRequestDetailId
})

const setFleetAfeChangeLog = (fleetAfeChangeLog?: any) => ({
    type: SET_FLEET_AFE_CHANGE_LOG,
    fleetAfeChangeLog: fleetAfeChangeLog
})

export {
    getFleetAssetChangeLog,
    setFleetAssetChangeLog,
    getFleetAfeChangeLog,
    setFleetAfeChangeLog
}